import { loadScript } from '@direct-frontend/stdlib';

/*
 * Принимаемые аргументы для метода загрузки скрипта плеера
 */
type LoadScriptProps = {
    cspNonce?: string;
    version?: string;
};

class SingletonPromise {
    static promise: Promise<void>;

    static createLoadPromise(props?: LoadScriptProps) {
        if (SingletonPromise.promise) {
            return SingletonPromise.promise;
        }

        SingletonPromise.promise = new Promise(async (resolve, reject) => {
            try {
                const version = props?.version || 'stable';
                const scriptUrl = `https://frontend.vh.yandex.ru/${version}/player_version/player.js`;

                await loadScript({
                    crossOrigin: 'disabled',
                    src: scriptUrl,
                    cspNonce: props?.cspNonce,
                });

                resolve();
            } catch (error) {
                reject(
                    error instanceof Error ? error : { name: 'YandexPlayer load script error', message: String(error) }
                );
            }
        });

        return SingletonPromise.promise;
    }
}

export const loadVideoPlayer = (props?: LoadScriptProps) => SingletonPromise.createLoadPromise(props);
